module.exports = __webpack_public_path__ + "static/media/ICU.a9a1f7b9.jpg";